import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InviteComponent } from './invite.component';
import { SharedModule } from '../../shared/shared.module';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg';
import { NzCardModule } from 'ng-zorro-antd/card';

@NgModule({
  declarations: [InviteComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    InlineSVGModule.forRoot(),
    NzButtonModule,
    NzFormModule,
    NzInputModule,
    NzCardModule,
  ],
})
export class InviteModule {}
